<template>
  <StandardTemplate class="max-w-[1600px] mb-24">
    <div class="flex flex-col xl:flex-row flex-grow
                pt-8 lx:pt-9">

      <div class="container-blue flex flex-col items-center xl:min-h-[38rem]
                  sm:flex-row xl:flex-col xl:basis-2/5 flex-grow
                  pt-6 pb-9 mb-3 xl:mb-0 xl:mr-5 4xl:mr-10">
        <baseLoading v-if="!userProfile || loading" class="mx-auto" />
        <template v-else>
          <div class="relative xl:inline-flex mx-auto sm:mr-5 xl:mr-0 sm:ml-6 xl:ml-0 mb-3">
            <baseIcon v-if="userProfile && !tmpProfile?.profilePhoto" :text="initials" themeName="main" diameter="8">
            </baseIcon>
            <img v-else :src="`https://storage.googleapis.com/assets.talkatoo.ai/profile-photos/${tmpProfile?.profilePhoto}`"
                 class="min-h-32 min-w-32 h-32 w-32 rounded-full"
                 :style="imageBorder ? `border: ${imageBorder} 2px solid;` : ''"
            />
            <button id="editProfileImage" class="absolute right-0 bottom-0 h-8 w-8
                          rounded-full bg-main-alt border-2 border-white
                          flex justify-center items-center"
                    @click="togglePickerModal">
              <span class="material-icons text-white text-xl"> edit</span>
            </button>
          </div>
          <div class="flex flex-col xl:w-full items-center sm:items-start xl:items-center flex-grow">
            <span id="fullName" class="px-6 text-2xl font-bold font-montserrat text-neutral-darker text-center sm:text-left xl:text-center">
              {{ fullName }}
            </span>
            <span class="px-6 text-neutral font-roboto text-sm mb-4">
              {{ userProfile.jobTitle }}
            </span>
            <div class="hidden xl:block border-t border-neutral-lighter w-full mb-5"></div>
            <div class="hidden xl:flex text-center font-bold font-roboto text-sm mb-4">
              Roles and Permissions
            </div>
            <div class="flex justify-center sm:justify-start xl:justify-center flex-wrap gap-1 text-neutral-darker
                        sm:w-3/4 xl:w-full px-6 xl:px-12 text-xs font-normal font-roboto">

              <div class="hidden last:flex bg-pastel-blue-light p-1 rounded-[4px] capitalize">
                None
              </div>
              <div v-for="perm in listizePermissions" :key="perm"
                   class="bg-pastel-blue-light p-1 rounded-[4px] capitalize">
                {{ perm }}
              </div>

            </div>
            <div class="hidden xl:block border-t border-neutral-lighter w-full mt-5"></div>
          </div>
        </template>
        <div v-if="$store.getters.getUserPerms.user_management" class="hidden xl:flex">
          <button class="btn-secondary-delete text-sm font-bold px-8 py-2"
                  @click="toggleRemoveModal">
            Remove User
          </button>
        </div>
      </div>
      <BaseBox title="User Details" class="flex-grow xl:basis-4/5">
        <BaseLoading v-if="!tmpProfile" />
        <template v-else>
          <div class="flex flex-col sm:flex-row xl:pt-5">
            <baseInput v-model="tmpProfile.firstName" name="firstName" label="First Name*" class="sm:basis-1/2 pb-7 md:pb-10 xl:pb-7 2xl:pb-10 sm:mr-3 xl:mr-5"
                       @input="change" />
            <baseInput v-model="tmpProfile.lastName" name="lastName" label="Last Name*" class="sm:basis-1/2 pb-7 md:pb-10 xl:pb-7 2xl:pb-10"
                       @input="change" />
          </div>
          <div class="flex flex-col sm:flex-row">
            <baseInput v-model="tmpProfile.jobTitle" name="jobTitle" label="Job Title" class="sm:basis-1/2 pb-7 md:pb-10 xl:pb-7 2xl:pb-10 sm:mr-3 xl:mr-5"
                       @input="change" />
            <baseInput v-model="tmpProfile.phoneNumber" name="phoneNumber" label="Phone Number" class="sm:basis-1/2 pb-7 md:pb-10 xl:pb-7 2xl:pb-10"
                       @input="change" />
          </div>
          <BaseMultiSelect class="mt-2 pb-7 md:pb-10 xl:pb-7 2xl:pb-10" label="permissions"
                           :value="permissions"
                           :disabled="!$store.getters.getUserPerms.user_management || pendingUserManagementRequest"
                           :disabledList="disabledList()"
                           @click-out="() => { }"
                           @update:value="changePerms" />
          <div class="flex flex-col sm:flex-row ">
            <baseInput v-model="tmpProfile.email" name="email" label="Email" class="basis-full opacity-30 pb-7 md:pb-10 xl:pb-7 2xl:pb-10"
                       :disabled="true" />
            <div v-if="userId != currentUser && $store.getters.getUserPerms.user_management"
                 class="flex ml-3">
              <button class="btn-secondary whitespace-nowrap text-sm font-bold mt-2 h-11 py-2 px-4"
                      @click="sendPasswordReset">
                Send Password Reset
              </button>
            </div>
          </div>
          <div v-if="userId == currentUser" class=" flex w-full flex-col sm:flex-row">

            <baseInput v-model="currentPass" name="currentPassword"
                       class="flex basis-1/2 pb-7 md:pb-10 xl:pb-7 2xl:pb-10 sm:mr-3 xl:mr-5"
                       label="Current Password"
                       type="password"
                       :errorMessage="currPassError" />
            <div class="relative basis-1/2 pb-7 md:pb-10 xl:pb-7 2xl:pb-10">
              <baseInput v-model="newPass" name="newPassword"
                         label="New Password"
                         :type="showPass ? 'text' : 'password'"
                         :errorMessage="newPassError" />
              <button aria-hidden="true"
                      class="absolute right-3 top-6 rounded-full text-xs text-neutral-light font-roboto font-semibold"
                      @click="showPass = !showPass">
                {{ showPass ? "HIDE" : "SHOW" }}
              </button>
            </div>
            <button id="savePassword"
                    class="btn-secondary text-sm font-bold ml-3 mt-2 h-11 py-2 px-4"
                    :disabled="!newPassValid || pendingChange"
                    @click="submitPassword">
              Update </button>
          </div>
        </template>
        <div :class="['hidden xl:flex flex-grow justify-start items-end pb-5', changeMade ? '' : 'invisible']">
          <button id="saveProfile" class="btn-primary font-bold text-sm py-3 px-4" :disabled="pendingChange" @click="submitProfile">
            Save Changes
          </button>
        </div>
      </BaseBox>
    </div>

    <BaseModal v-if="!loading" title="Select your profile image" :toDisplay="showPickerModal" @toggleEvent="togglePickerModal">
      <div class="flex flex-wrap justify-center sm:grid sm:grid-cols-4 md:grid-cols-5 gap-4 p-4 max-h-[80vh] overflow-y-scroll">
        <button v-for="index in 20" :key="index"
                class="inline-block border-3 border-white
                 aria-selected:border-main-alt aria-selected:rounded-sm
                 hover:border-main-alt hover:border-opacity-50"
                :aria-selected="`profile-${index}.png` === selectedImage"
                @click="selectImage(index)">
          <img
            :src="`https://storage.googleapis.com/assets.talkatoo.ai/profile-photos/profile-${index}.png`"
            class="min-h-[8rem] min-w-[8rem] max-h-[8rem] max-w-[8rem] m-[1px] rounded-sm
                 "
            :aria-selected="`profile-${index}.png` === selectedImage" />
        </button>
        <!-- <button class="inline-block relative min-h-[8rem] min-w-[8rem] h-32 w-32 aria-selected:border-3 aria-selected:border-main-alt aria-selected:rounded-sm"
                :aria-selected="'' == selectedImage"
                @click="selectImage('none')">
          <baseIcon :text="initials" themeName="main" diameter="6.5">
          </baseIcon>
        </button> -->
      </div>
      <div class="flex justify-center p-5 border-t border-neutral-light">
        <button class="w-40  mr-3 py-2 px-4 text-sm font-bold border rounded-lg text-neutral-dark border-neutral-dark"
                @click="cancelPickerModal">
          CANCEL
        </button>
        <button class="btn-primary w-40 text-sm py-2 px-4 font-bold"
                @click="confirmImage">
          SELECT IMAGE
        </button>
      </div>
    </BaseModal>
    <BaseModal title="Remove User" :toDisplay="showRemoveModal" @toggleEvent="toggleRemoveModal">
      <div class="p-4">
        <div class="flex flex-col justify-center py-6">
          <baseIcon v-if="userProfile && !tmpProfile?.profilePhoto" :text="initials" themeName="main" diameter="8">
          </baseIcon>
          <img v-else :src="`https://storage.googleapis.com/assets.talkatoo.ai/profile-photos/${tmpProfile?.profilePhoto}`"
               class="h-28 w-28 rounded-full mx-auto"
               :style="imageBorder ? `border: ${imageBorder} 2px solid;` : ''"
          />
          <span class="pt-6 pb-4 text-2xl font-bold text-center"> Are you sure you want <br /> to remove this user?</span>
          <span class="text-center text-base text-main-alt font-bold font-roboto">{{ userProfile.email }}</span>
        </div>
        <div class="flex flex-col mx-2 sm:mx-12 py-5 bg-error bg-opacity-20 border-l-2 border-error">
          <span class="material-icons text-error text-4xl text-center">warning</span>
          <span class="ml-12 pt-4 pr-8 sm:pr-20 text-neutral-darker">
            This cannot be undone, and the user will lose the ability&nbsp; <br class="hidden md:block" />
            to dictate and record notes.
          </span>
        </div>
      </div>

      <div class="flex w-full justify-center lg:justify-end  border-t border-neutral-light py-6 lg:px-11">
        <button class="mr-3 py-2 px-4 text-xs text-neutral font-bold rounded-lg"
                @click="toggleRemoveModal">
          CANCEL
        </button>
        <button class="btn-primary-delete px-4 py-2 text-xs font-bold  bg-opacity-0"
                @click="removeUser">
          REMOVE USER
        </button>
      </div>

    </BaseModal>

    <div v-if="$store.getters.getUserPerms.user_management" class="flex xl:hidden justify-center pt-6">
      <button class="btn-secondary-delete w-48 text-xs font-bold px-12 py-3 bg-opacity-0"
              @click="toggleRemoveModal">
        Remove User
      </button>
    </div>
  </StandardTemplate>
  <div v-if="changeMade" class="fixed flex floating-save xl:mx-4 xl:hidden justify-center bottom-0 p-4 bg-white">
    <button id="saveProfile" class="btn-primary w-48 font-bold text-sm py-3 px-4" :disabled="pendingChange" @click="submitProfile">
      Save Changes
    </button>
  </div>
</template>

<script src="./UserProfile.js"></script>
<style scoped src="./UserProfile.css"></style>